import { useContext } from 'react'
import { MfeLoaderContext } from 'src/components/MfeLoader'

export default function useMfeLoader() {
    return useContext(MfeLoaderContext)
}
